import { ConfigBlock, DataConfigBlock } from "@soft-db/monitoring-api-client";
import { Component } from "vue";
import { CommentBar } from "./comment-bar";
import { CommentBox } from "./comment-box";
// import { Text } from './text';
import { CursorValue } from "./cursor-value";
import { DynamicImage } from "./dynamic-image";
import { EventBar } from "./event-bar";
import { EventList } from "./event-list";
import { EventWaveform } from "./event-waveform";
import { ImageViewer } from "./image-viewer";
import { MapPlugin } from "./map";
import { MediaPlayer } from "./media-player";
import { Spectrum } from "./spectrum";
import { TimeHistory } from "./time-history";
import { VibEvent } from "./vib-event";
import { VibrationCriteriaGraph } from "./vibration-criteria-graph";
import { VibrationEventSummary } from "./vibration-event-summary";

export type PluginId =
	| "comment-bar"
	| "comment-box"
	| "dynamic-image"
	| "event-bar"
	| "event-list"
	| "event-waveform"
	| "image-viewer"
	| "mediaplayer"
	| "safe-limit-graph"
	| "simpletext"
	| "spectrum"
	| "timehistory"
	| "vib-event"
	| "vibration-event-summary"
	| "cursor-value"
	| "map_plugin"
	| "";

export type PluginType = "history" | "cursor" | "event";

export type PluginHeader = {
	visible?: boolean;
	fullscreen?: boolean;
	edit?: boolean;
};

export type PluginOptions = {
	options: ConfigBlock | null | undefined;
	data: DataConfigBlock | null | undefined;
};

export type Plugin = {
	id: PluginId;
	name: string;
	currentVersion: number;
	type: PluginType;
	header: PluginHeader;
	component: Component | null;
	config: Component | null;
	dataConfig: Component | null;

	// The key is the version we are migrating from
	migrations: Partial<Record<number, (options: PluginOptions) => PluginOptions>>;

	dimension?: {
		minWidth?: number;
		minHeight?: number;
	};

	defaultOptionsResolver: () => ConfigBlock | undefined;
	defaultDataResolver: () => DataConfigBlock | undefined;
};

export const Plugins: Record<string, Plugin> = {
	[TimeHistory.id]: TimeHistory,
	[Spectrum.id]: Spectrum,
	[EventBar.id]: EventBar,
	[EventList.id]: EventList,
	[EventWaveform.id]: EventWaveform,
	[MediaPlayer.id]: MediaPlayer,
	[ImageViewer.id]: ImageViewer,
	[VibrationEventSummary.id]: VibrationEventSummary,
	[VibrationCriteriaGraph.id]: VibrationCriteriaGraph,
	[CommentBar.id]: CommentBar,
	[VibEvent.id]: VibEvent,
	[DynamicImage.id]: DynamicImage,
	[CommentBox.id]: CommentBox,
	[CursorValue.id]: CursorValue,
	[MapPlugin.id]: MapPlugin,
};
